import {
  Experience,
  PublicExperiencePayment
} from '../../api/experiences/model'
import { PaymentStrategyType } from '../../api/payment/model'
import { getPaymentLabelByStrategyAndType } from '../../utils/getPaymentLabelByStrategyAndType'

export function getPaymentCopy(
  payment: PublicExperiencePayment,
  deps: {
    currencyFormatter: (amount: number) => string
  }
) {
  return `From ${deps.currencyFormatter(payment.strategyAmount)} deposit / ${
    payment.strategy === PaymentStrategyType.PARTYSIZE ? 'person' : 'booking'
  }`
}

export function getExperiencePaymentDetailLabel(
  experience: Experience,
  formatCurrency: (
    amount: number,
    options?: { trailingZeros: boolean }
  ) => string
) {
  if (!experience.payment) {
    return null
  }

  const formattedAmount = formatCurrency(experience.payment.strategyAmount, {
    trailingZeros: false
  })

  return getPaymentLabelByStrategyAndType(
    formattedAmount,
    experience.payment.type,
    experience.payment.strategy,
    '/'
  )
}
